// IndexedDB fuer den Offline-Betrieb (Phase 9, Projektplan 10.1).
//
// Zwei Tabellen: bundles haelt die Stammdaten (Kennzeichen, Kreisgeometrie)
// fuer den Fall, dass ein Start ohne Netz passiert. outbox haelt neue
// Sichtungen, die waehrend einer Offline-Phase entstanden sind, bis sie
// nachgesendet werden koennen.

import Dexie, { type Table } from "dexie";

export interface BundleEintrag {
  // "me" ist kein Bundle im eigentlichen Sinn, teilt sich aber dieselbe
  // Ablage: die letzte erfolgreiche Antwort von /api/me, damit ein
  // Neuladen ohne Netz nicht schon an der Anmeldepruefung scheitert (siehe
  // Kommentar in lib/me.ts).
  key: "plates" | "regions" | "me";
  data: unknown;
  fetchedAt: number;
}

export interface AusstehendeSichtung {
  /** Auch der Primaerschluessel: macht das Nachsenden idempotent. */
  clientUuid: string;
  collectionId: number;
  plateCodeId: number;
  punkte: number;
  createdAt: string;
}

/**
 * FALLE: Der Name der IndexedDB bleibt "kennzeichendex", auch seit die App
 * Kennzeichensammler heisst. Er ist ein Speicherschluessel im Browser, kein
 * Anzeigetext: wer ihn aendert, legt bei jedem Nutzer eine leere zweite
 * Datenbank an. Die Bundles wuerden neu geladen, die Outbox mit noch nicht
 * gesendeten Sichtungen waere weg.
 */
class KennzeichenDexDB extends Dexie {
  bundles!: Table<BundleEintrag, string>;
  outbox!: Table<AusstehendeSichtung, string>;

  constructor() {
    super("kennzeichendex");
    this.version(1).stores({
      bundles: "key",
      outbox: "clientUuid, collectionId",
    });
  }
}

export const db = new KennzeichenDexDB();
